import { sharedChapters } from './chapters';
import type { Guide, GuideAudience } from './types';

/**
 * A guide for one kind of organization: its own opening, ideas and launch
 * playbook around the shared chapters, with that audience's notes kept.
 */
export function audienceGuide(o: {
  audience: GuideAudience;
  title: string;
  subtitle: string;
  reviewed: string;
  why: { title: string; summary: string; markdown: string };
  ideas: { summary: string; markdown: string };
  playbook: { summary: string; markdown: string };
}): Guide {
  const s = sharedChapters(o.audience);
  return {
    slug: o.audience,
    title: o.title,
    subtitle: o.subtitle,
    audiences: [o.audience],
    pdf: `/guides/${o.audience}/nirvik-ready-guide.pdf`,
    reviewed: o.reviewed,
    chapters: [
      { slug: 'why', ...o.why },
      s['at-a-glance'],
      s['getting-started'],
      s['set-up'],
      s.people,
      s['ready-made'],
      s['make-it-yours'],
      s['build-a-course'],
      s.assessments,
      s.events,
      s.assign,
      s['spread-the-word'],
      s.impact,
      s.support,
      s.trust,
      { slug: 'ideas', title: 'Ideas that work', ...o.ideas },
      { slug: 'launch-playbook', title: 'Launch playbook', ...o.playbook },
      s['checklists-faq'],
    ],
  };
}
